export const mapToOptions = (items = [], valueKey, labelKey, additionalKeys = []) => {
  return items.map(item => ({
    value: item[valueKey],
    label: item[labelKey],
    ...Object.fromEntries(additionalKeys.map(key => [key, item[key]])),
  }));
};